module.exports = __webpack_public_path__ + "img/fondos_pinguiigluu.078a09c5.jpg";